import React from "react";
import { Check, MapPin } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const neighborhoods = ["Leeds City Centre", "Headingley", "Roundhay", "Pudsey", "Horsforth", "Morley", "Beeston", "Garforth", "Chapel Allerton", "Rothwell"];
export default function TheBatonRougeServiceCircle() {
  return <section data-section-id="224833" id="our-leeds-service-radius" className="bg-background text-foreground relative w-full min-h-[700px] overflow-hidden flex items-center">
      {}
      <div className="absolute inset-0 bg-secondary z-0"></div>

      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647150/img/leeds_city_map_dark.png)] bg-cover bg-center opacity-40 z-0 mix-blend-luminosity"></div>

      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647150/img/mechanical_mesh_texture.png)] bg-cover bg-center opacity-20 z-0 mix-blend-overlay"></div>

      {}
      <div className="absolute top-1/2 left-1/2 md:left-[65%] lg:left-[70%] -translate-x-1/2 -translate-y-1/2 flex items-center justify-center z-10 pointer-events-none">
        {}
        <div className="absolute size-4 bg-primary rounded-full shadow-[0_0_25px_var(--color-primary)] z-20"></div>
        
        {}
        <div className="absolute size-24 bg-primary/20 rounded-full animate-ping z-10"></div>
        
        {}
        <div className="absolute size-48 border border-primary/30 rounded-full"></div>
        <div className="absolute size-80 border border-primary/15 rounded-full"></div>
        <div className="absolute size-96 border border-primary/10 rounded-full"></div>
        <div className="absolute w-[40rem] h-[40rem] border border-primary/5 rounded-full hidden md:block"></div>
      </div>

      {}
      <div className="container mx-auto px-4 relative z-20">
        <div className="max-w-md">
          <Card className="bg-secondary/80 backdrop-blur-xl border-white/10 shadow-3xl text-foreground">
            <CardHeader className="pb-4 border-b border-white/5">
              <div className="flex items-center gap-3 mb-2">
                <div className="p-2 bg-primary/10 rounded-lg">
                  <MapPin className="size-5 text-primary" />
                </div>
                <span className="text-sm font-semibold tracking-widest text-primary uppercase font-default">
                  Rapid Response Zone
                </span>
              </div>
              <CardTitle className="text-3xl font-default text-white uppercase tracking-tight">
                Leeds & Surrounding Areas
              </CardTitle>
              <CardDescription className="text-muted-foreground text-base mt-2 font-default">
                Our mobile tyre fitting units are stationed across Leeds, ensuring we reach you within 30-60 minutes for emergency repairs or scheduled fittings.
              </CardDescription>
            </CardHeader>
            <CardContent className="pt-6">
              <p className="text-sm text-muted-foreground mb-4 font-medium font-default">
                Primary Service Locations:
              </p>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-4">
                {neighborhoods.map((neighborhood, i) => <li key={i} data-index={i} className="flex items-center gap-2.5 group cursor-default">
                    <div className="flex items-center justify-center size-5 rounded-full bg-primary/10 shrink-0 transition-colors group-hover:bg-primary/30">
                      <Check className="size-3 text-primary" strokeWidth={3} />
                    </div>
                    <span className="text-sm font-default text-foreground/90 group-hover:text-primary transition-colors">
                      {neighborhood}
                    </span>
                  </li>)}
              </ul>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}